module.exports = __webpack_public_path__ + "static/media/logo.a4279494.svg";